import './Home.css';
import SideMenu from '../SideMenu';
import VoicemailIcon from '../../images/Portfolio2VoicemailIcon.png';
import MailIcon from '../../images/Portfolio2MailIcon.png';
import SethL from '../../images/SethLROOFI2P.jpg';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className = 'home'>
      <SideMenu />
      <div className = 'home-content'>
        <div className = 'home-content-content'>
          <div className = 'home-content-content-info'>
            <span className = 'home-content-content-info-title'>MY NAME IS <span className = 'home-content-content-info-title-special'>SETH LAMAR...</span></span>
            <span className = 'home-content-content-info-subtitle'><span className = 'home-content-content-info-subtitle-special'>Fullstack Engineer</span> based in <span className = 'home-content-content-info-subtitle-special'>New Jersey</span></span>
            <Link to={"/about"} className = 'home-content-content-info-button'>Let's talk</Link>
            <div className = 'home-content-content-info-contact'>
              <div className = 'home-content-content-info-contact-group'>
                <img className = 'home-content-content-info-contact-group-img' src = {MailIcon} />
                <span className = 'home-content-content-info-contact-group-text'>slprogram2005@gmail.com</span>
              </div>
            </div>
          </div>
          <div className = 'home-content-content-image'>
            <img className = 'home-content-content-image-img'  alt = "Seth LaMar" src = {SethL} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;